import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Branch } from './branch';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BranchService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<Branch[]> {
    return this.httpClient.get<Branch[]>(this.baseUrl + 'api/BranchApi')
  }
  Post(branch: Branch): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/BranchApi/Add', branch, { headers: header, observe: 'response' })
  }
  Delete(branch: Branch) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/BranchApi/activeordeactive', branch, { headers: header, observe: 'response' })
  }
  Put(branch: Branch): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/BranchApi/Update', branch, { headers: header, observe: 'response' })
  }


}



